import { cn } from '@/utils';
import { AppImage } from '@/components/Images';
import { SkeletonLoader } from '@/components/Loaders';

/** Props for NavLogo component */
interface NavLogoProps {
  /** Additional class names for the logo component */
  className?: string;
  /** Whether the logo is in a loading state */
  isLoading?: boolean;
}

/**
 * Logo component that displays the application logo with optional loading state.
 */
export const NavLogo: React.FC<NavLogoProps> = ({ className, isLoading }) => (
  <div className="flex items-start justify-start">
    {isLoading ? (
      <div className="relative flex h-12 w-12 items-start justify-start">
        <SkeletonLoader height="full" width="full" rounded="full" className="absolute inset-0" />
      </div>
    ) : (
      <div
        className={cn(
          'flex shrink-0 items-start justify-start',
          'mx-auto rounded-full bg-neutral-white p-2',
          className,
        )}
      >
        <AppImage
          src="/logos/Logo.svg"
          alt="J&J Logo"
          width={32}
          height={32}
          skeletonRounding="full"
        />
      </div>
    )}
  </div>
);

NavLogo.displayName = 'NavLogo';

export default NavLogo;
